"use client";

import { Hero } from "./hero";
import { Overview } from "./overview";
import { Story } from "./story";
import { WhatWeDo } from "./what-we-do";
import { Values } from "./values";
import { PlatformSummary } from "./platform-summary";
import { Clients } from "./clients";
import { Team } from "./team";
import { Impact } from "./impact";
import { Approach } from "./approach";
import { Technology } from "./technology";
import { Commitment } from "./commitment";
import { GlobalOps } from "./global-ops";
import { Leadership } from "./leadership";
import { Careers } from "./careers";
import { AboutContact } from "./contact";
import { Trust } from "./trust";
import { Future } from "./future";
import { Legal } from "./legal";
import { GetStarted } from "./get-started";

export function AboutPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <Overview />
      </div>
      <Story />
      <div className="bg-aurora-cyan">
        <WhatWeDo />
      </div>
      <Values />
      <div className="bg-aurora-crimson">
        <PlatformSummary />
      </div>
      <Clients />
      <div className="bg-aurora-purple">
        <Team />
      </div>
      <Impact />
      <div className="bg-aurora-emerald">
        <Approach />
      </div>
      <Technology />
      <div className="bg-aurora-amber">
        <Commitment />
      </div>
      <GlobalOps />
      <div className="bg-aurora-purple">
        <Leadership />
      </div>
      <Careers />
      <AboutContact />
      <div className="bg-aurora-cyan">
        <Trust />
      </div>
      <Future />
      <Legal />
      <GetStarted />
    </>
  );
}
